// Value Tests
export const testEmail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
    ? ""
    : "Invalid email.";
export const testRequired = (value) => Boolean(value.trim().length);

export const submitFormik = async ({ onSubmit, onSuccess, formikProps }) => {
  const { setFieldError, setErrors, resetForm } = formikProps;
  const res = await onSubmit();
  const error = res?.error;
  const handleSuccess = async () => {
    onSuccess && (await onSuccess(res));
    resetForm?.();
  };
  return error
    ? Object.keys(error.fieldErrors || {}).length
      ? Object.entries(error.fieldErrors).map(([field, error]) =>
          setFieldError?.(field, error)
        )
      : error.message && setErrors?.({ form: error.message })
    : handleSuccess();
};

export const getSelectionFromValue = (items, value) =>
  value ? items.find((i) => i.value === value) : null;
